import { lazy } from "react";
// Billing Dashboard — producción diaria y estados de cuenta con datos REALES
// de AdvancedMD (rutas financieras del doc 21_Endpoints_Financieros_59_Rutas).

const BillingDashboardPage = lazy(() => import("./pages/BillingDashboardPage"));

export const billingDashboardRoutes = [
  { path: "/billing-dashboard", element: <BillingDashboardPage /> },
];
